import constants from '../services/constants';
import { atom } from 'recoil';

const teamRoleColWidthAtom = atom<number>({
    key: constants.teamRoleColWidthAtom,
    default: 0,
});

export default teamRoleColWidthAtom;